import { Select, Typography, Card } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
const { Title } = Typography;
export default function AnalyticsFilters({
  projects,
  selectedProject,
  onProjectChange,
  selectedRegistroFilter,
  onRegistroFilterChange,
}) {
  return (
    <Card
      style={{
        padding: "10px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        backgroundColor: "#042956",
        marginBottom: "24px",
        border: "none",
        width: "100%"
      }}
    >
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "16px"
      }}>
        <Title level={2} style={{
          margin: 0,
          color: "#ffffff",
          fontSize: "20px",
          fontWeight: 600
        }}>
          <FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginRight: "12px", opacity: 0.9 }} />
          Filtro de búsqueda
        </Title>
      </div>
      <div style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        alignItems: "center"
      }}>
        <div style={{ flex: "1 1 200px", minWidth: "200px" }}>
          <Select
            value={selectedProject}
            onChange={onProjectChange}
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Todos los proyectos"
            options={[
              { label: "Todos los proyectos", value: "all" },
              ...projects.map((p) => ({
                label: p,
                value: p,
              })),
            ]}
          />
        </div>
        <div style={{ flex: "1 1 200px", minWidth: "200px" }}>
          <Select
            value={selectedRegistroFilter}
            onChange={onRegistroFilterChange}
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Todos los registros"
            options={[
              { label: "Todos los registros", value: "all" },
              { label: "Participante", value: "participante" },
              { label: "Organización", value: "organizacion" },
              { label: "Sin registro", value: "sin_registro" },
            ]}
          />
        </div>
      </div>
    </Card>
  );
}
